import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '../button/button.component';
import { ButtonType } from '../../../shared/enums/button-type.enums';
import { Router } from '@angular/router';
import { CaasError404 } from '../../../shared/interfaces/caas/caas.interface';
import { CaasRoutesService } from '../../../services/caas-routes.service';
import { ImagesService } from '../../../services/images.service';
import { CapitalizePipe } from '../../capitalize.pipe';

@Component({
  selector: 'hdi-not-found-box',
  standalone: true,
  imports: [ButtonComponent, CommonModule, CapitalizePipe],
  templateUrl: './not-found-box.component.html',
  styleUrls: ['./not-found-box.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class NotFoundBoxComponent implements OnChanges {
  @Input() caasData?: CaasError404;
  @Input() title?: string;
  @Input() description?: string;
  @Input() imageUrl?: string;
  @Input() imageAlt: string = '';
  @Input() linkLabel?: string;
  @Input() linkUrl?: string;
  @Input() errorCode?: '404' | '500';
  public readonly ButtonType = ButtonType;
  constructor(
    private router: Router,
    private caasRoutesService: CaasRoutesService,
    private imagesService: ImagesService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasData']) {
      if (this.caasData?.formData?.st_bodytext?.value) {
        this.description = this.caasData.formData.st_bodytext.value;
      }
      if (this.caasData?.formData?.st_header?.value) {
        this.title = this.caasData.formData.st_header.value;
      }
      if (this.caasData?.formData?.st_image?.value?.url) {
        this.imageUrl = this.caasData.formData.st_image.value.url;
        this.imageAlt =
          this.imagesService.getAltTextById(
            this.caasData.formData.st_image.value.identifier ?? ''
          ) ?? '';
      }

      if (
        this.caasData?.formData?.st_link?.value?.formData?.lt_link_label?.value
      ) {
        this.linkLabel =
          this.caasData.formData.st_link.value.formData.lt_link_label.value;
      }
      if (
        this.caasData?.formData?.st_link?.value?.formData?.lt_link_internal
          ?.value?.uid
      ) {
        this.linkUrl =
          this.caasRoutesService.getSeoRouteByIdentifier(
            this.caasData?.formData.st_link.value.formData.lt_link_internal
              .value.identifier,
            this.router.config
          )?.path ?? '404';
      }
    }
  }
}
